import { render, staticRenderFns } from "./kneeHurtScore.vue?vue&type=template&id=8c15c87c&scoped=true&"
import script from "./kneeHurtScore.vue?vue&type=script&lang=js&"
export * from "./kneeHurtScore.vue?vue&type=script&lang=js&"
import style0 from "./kneeHurtScore.vue?vue&type=style&index=0&id=8c15c87c&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c15c87c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c15c87c')) {
      api.createRecord('8c15c87c', component.options)
    } else {
      api.reload('8c15c87c', component.options)
    }
    module.hot.accept("./kneeHurtScore.vue?vue&type=template&id=8c15c87c&scoped=true&", function () {
      api.rerender('8c15c87c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/library/kneeHurtScore.vue"
export default component.exports